import { render, staticRenderFns } from "./ConsentCheckboxes.vue?vue&type=template&id=cc823c0e&scoped=true"
import script from "./ConsentCheckboxes.vue?vue&type=script&lang=js"
export * from "./ConsentCheckboxes.vue?vue&type=script&lang=js"
import style0 from "./ConsentCheckboxes.vue?vue&type=style&index=0&id=cc823c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc823c0e",
  null
  
)

export default component.exports